import { NAVIGATION } from './const';
import { INavigation, INavigationItem } from './types';

export const generateBottomNavigation = (navigationData: INavigationItem[] | undefined ): INavigation[] | null => {
  if (!navigationData) {
    return null;
  }

  return [
    {
      title: 'Products',
      nodes: navigationData.find((navItem: INavigationItem) => navItem.name === NAVIGATION.products)?.nodes,
    },
    {
      title: 'Contacts',
      nodes: navigationData.find((navItem: INavigationItem) => navItem.name === NAVIGATION.contacts)?.nodes,
    },
    {
      title: 'Support',
      nodes: navigationData.find((navItem: INavigationItem) => navItem.name === NAVIGATION.support)?.nodes,
    },
    {
      title: 'Events / Blog',
      nodes: navigationData.find((navItem: INavigationItem) => navItem.name === NAVIGATION.events)?.nodes,
    },
    {
      title: 'About',
      nodes: navigationData.find((navItem: INavigationItem) => navItem.name === NAVIGATION.about)?.nodes,
    },
  ];
};


// WEBPACK FOOTER //
// ./src/components/Footer/utils.ts